// extracted by mini-css-extract-plugin
export default {"container":"Quote_container__ku9xa","quote":"Quote_quote__SiZ2P","dice":"Quote_dice__xVWzH","title":"Quote_title__87lne","hr":"Quote_hr__vziRw"};